export default __webpack_public_path__ + "static/media/4a47ac10693303128444e265633b4b95.svg";